

// import React, { useState } from 'react';
// import axios from 'axios';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   useMediaQuery,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from '@mui/material';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import backgroundImage from '../../../assets/hij.png';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../../../Commonlibs/userSlice';

// const HeroSection = () => {
//   const [activeTab, setActiveTab] = useState('Buy');
//   const [city, setCity] = useState('');
//   const [citySuggestions, setCitySuggestions] = useState([]);
//   const [showCitySuggestions, setShowCitySuggestions] = useState(false);
//   const [area, setArea] = useState('');
//   const [areaSuggestions, setAreaSuggestions] = useState([]);
//   const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);
  
//   // Debounce timers
//   const [cityDebounceTimer, setCityDebounceTimer] = useState(null);
//   const [areaDebounceTimer, setAreaDebounceTimer] = useState(null);
  
//   // Field validation states
//   const [cityError, setCityError] = useState('');
//   const [areaError, setAreaError] = useState('');
  
//   // Dialog state
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [dialogMessage, setDialogMessage] = useState('');
//   const [dialogSeverity, setDialogSeverity] = useState('info');
  
//   // NEW: Cache for area suggestions
//   const [areaCacheMap, setAreaCacheMap] = useState({});
  
//   // NEW: Loading state for areas
//   const [isLoadingAreas, setIsLoadingAreas] = useState(false);
  
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const user = useSelector(selectUser);
  
//   const tabs = ['Buy', 'Rent']; //'Plots'
  
//   const categoryMap = {
//     'Buy': 'sale',
//     'Rent': 'rent',
//     // 'Plots': 'plot'
//   };
  
//   const handleCloseDialog = () => {
//     setDialogOpen(false);
//   };
  
//   const showDialog = (message, severity = 'info') => {
//     setDialogMessage(message);
//     setDialogSeverity(severity);
//     setDialogOpen(true);
//   };
  
//   const validateCity = (value) => {
//     if (value) {
//       if (!/^[a-zA-Z\s]+$/.test(value)) {
//         setCityError('City should contain only letters and spaces');
//         return false;
//       }
//     }
//     setCityError('');
//     return true;
//   };
  
//   const validateArea = (value) => {
//     if (value) {
//       if (!/^[a-zA-Z0-9\s,.-]+$/.test(value)) {
//         setAreaError('Area should contain only alphanumeric characters, spaces and basic punctuation');
//         return false;
//       }
//     }
//     setAreaError('');
//     return true;
//   };
  
//   const fetchCitySuggestions = async (query) => {
//     if (!query || query.trim().length < 1) {
//       setCitySuggestions([]);
//       setShowCitySuggestions(false);
//       return;
//     }
    
//     try {
//       const response = await axios.get(
//         `https://propertydealstalk.com/api/property/cities?q=${encodeURIComponent(query)}`
//       );
//       console.log('City API Response:', response.data);
      
//       if (response.data.success && response.data.data && response.data.data.length > 0) {
//         setCitySuggestions(response.data.data);
//         setShowCitySuggestions(true);
//       } else {
//         setCitySuggestions([]);
//         setShowCitySuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching city suggestions:', error);
//       console.error('Error details:', error.response?.data);
//       setCitySuggestions([]);
//       setShowCitySuggestions(false);
//     }
//   };
  
//   // UPDATED: Area suggestions with caching and loading state
//   const fetchAreaSuggestions = async (query) => {
//     if (!city || city.trim() === '') {
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//       return;
//     }
    
//     // Create cache key
//     const cacheKey = `${city.trim()}_${query.trim()}`;
    
//     // Check if we have cached results
//     if (areaCacheMap[cacheKey]) {
//       console.log('Using cached area suggestions');
//       setAreaSuggestions(areaCacheMap[cacheKey]);
//       setShowAreaSuggestions(true);
//       return;
//     }
    
//     setIsLoadingAreas(true);
    
//     try {
//       const response = await axios.get(
//         `https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`
//       );
//       console.log('Area API Response:', response.data);
      
//       if (response.data.success && response.data.areas && response.data.areas.length > 0) {
//         // Cache the results
//         setAreaCacheMap(prev => ({
//           ...prev,
//           [cacheKey]: response.data.areas
//         }));
//         setAreaSuggestions(response.data.areas);
//         setShowAreaSuggestions(true);
//       } else {
//         setAreaSuggestions([]);
//         setShowAreaSuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching area suggestions:', error);
//       console.error('Error details:', error.response?.data);
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     } finally {
//       setIsLoadingAreas(false);
//     }
//   };
  
//   const saveBuyerSearch = async (searchData) => {
//     try {
//       const response = await axios.post(
//         'https://propertydealstalk.com/api/buyerAnalytics/saveBuyerSearch',
//         searchData
//       );
//       if (response.data.statusCode === 200) {
//         console.log('Search saved successfully:', response.data);
//       } else {
//         console.error('Failed to save search:', response.data);
//       }
//     } catch (error) {
//       console.error('Error saving search:', error);
//     }
//   };
  
//   const handleSearch = async () => {
//     const isCityValid = validateCity(city);
//     const isAreaValid = validateArea(area);
    
//     if (!isCityValid || !isAreaValid) {
//       return;
//     }
    
//     const hasCity = city && city.trim() !== '';
//     const hasArea = area && area.trim() !== '';
    
//     if (!hasCity && !hasArea) {
//       showDialog("Please provide at least one search parameter", "warning");
//       return;
//     }
    
//     const params = new URLSearchParams();
//     const categoryType = categoryMap[activeTab];
    
//     if (categoryType) {
//       params.append('type_of_category', categoryType);
//     }
    
//     if (hasCity) {
//       params.append('city', city.trim());
//     }
    
//     if (hasArea) {
//       params.append('area_name', area.trim());
//     }
    
//     if (user && user.id) {
//       const searchData = {
//         buyer_id: user.id,
//         location: hasCity ? city.trim() : null,
//         area: hasArea ? area.trim() : null,
//         property_type: null,
//         min_price: null,
//         max_price: null
//       };
//       await saveBuyerSearch(searchData);
//     }
    
//     navigate({
//       pathname: '/property',
//       search: params.toString()
//     });
    
//     showDialog('Searching for properties...', 'success');
//   };
  
//   const handleCityChange = (e) => {
//     const value = e.target.value;
//     setCity(value);
//     validateCity(value);
    
//     // Clear existing timer
//     if (cityDebounceTimer) {
//       clearTimeout(cityDebounceTimer);
//     }
    
//     // Set new timer for debouncing
//     const newTimer = setTimeout(() => {
//       if (value.trim().length >= 1) {
//         fetchCitySuggestions(value.trim());
//       } else {
//         setCitySuggestions([]);
//         setShowCitySuggestions(false);
//       }
//     }, 300);
    
//     setCityDebounceTimer(newTimer);
//   };
  
//   // UPDATED: Reduced debounce time to 100ms
//   const handleAreaChange = (e) => {
//     const value = e.target.value;
//     setArea(value);
//     validateArea(value);
    
//     // Clear existing timer
//     if (areaDebounceTimer) {
//       clearTimeout(areaDebounceTimer);
//     }
    
//     // Set new timer for debouncing - REDUCED to 100ms
//     const newTimer = setTimeout(() => {
//       if (city && city.trim() !== '') {
//         fetchAreaSuggestions(value);
//       }
//     }, 100); // Reduced from 300ms to 100ms
    
//     setAreaDebounceTimer(newTimer);
//   };
  
//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         height: '600px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundImage: `url(${backgroundImage})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         color: 'white',
//         fontFamily: 'Outfit',
//         px: '16px',
//       }}
//     >
//       <Dialog
//         open={dialogOpen}
//         onClose={handleCloseDialog}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//       >
//         <DialogTitle id="alert-dialog-title">
//           {dialogSeverity === 'success' ? 'Success' :
//            dialogSeverity === 'warning' ? 'Warning' :
//            dialogSeverity === 'error' ? 'Error' : 'Information'}
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="alert-dialog-description">
//             {dialogMessage}
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialog} autoFocus>
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Box
//         sx={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundColor: 'rgba(0,0,0,0.6)',
//           zIndex: 1,
//         }}
//       />

//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           width: '880px',
//           maxWidth: '100%',
//           fontFamily: 'Outfit',
//         }}
//       >
//         <Typography
//           variant="h3"
//           sx={{
//             textAlign: 'center',
//             fontWeight: 500,
//             mb: '8px',
//             fontSize: isMobile ? '28px' : '40px',
//             fontFamily: 'Outfit',
//           }}
//         >
//           Buy, Sell, Rent a Property made easy !
//         </Typography>

//         <Typography
//           variant="h6"
//           sx={{
//             textAlign: 'center',
//             fontWeight: 500,
//             mb: '32px',
//             fontSize: isMobile ? '16px' : '20px',
//             fontFamily: 'Outfit',
//           }}
//         >
//           Browse through thousands of properties for sale and rent
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'row',
//             justifyContent: isMobile ? 'center' : 'flex-start',
//             flexWrap: 'wrap',
//             gap: isMobile ? '5px' : '10px',
//             px: isMobile ? '0px' : '30px',
//             mb: '0px',
//           }}
//         >
//           {tabs.map((label) => (
//             <Box
//               key={label}
//               onClick={() => setActiveTab(label)}
//               sx={{
//                 width: isMobile ? '100px' : '160px',
//                 height: '40px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 borderTopLeftRadius: '8px',
//                 borderTopRightRadius: '8px',
//                 fontWeight: 500,
//                 fontFamily: 'Outfit',
//                 fontSize: '14px',
//                 textTransform: 'uppercase',
//                 cursor: 'pointer',
//                 backgroundColor: activeTab === label ? '#0052ff' : '#ffffff',
//                 color: activeTab === label ? '#ffffff' : '#000000',
//                 boxShadow: activeTab === label ? '0px 2px 8px rgba(0, 0, 0, 0.2)' : 'none',
//                 border: '1px solid grey',
//                 transition: 'all 0.3s ease',
//                 '&:hover': {
//                   backgroundColor: activeTab === label ? '#0041cc' : '#f5f5f5',
//                 },
//               }}
//             >
//               {label}
//             </Box>
//           ))}
//         </Box>

//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: isMobile ? 'column' : 'row',
//             alignItems: 'center',
//             justifyContent: 'flex-start',
//             backgroundColor: '#fff',
//             borderRadius: '12px',
//             padding: '20px',
//             mt: '0px',
//             ml: isMobile ? '0px' : '24px',
//             mr: isMobile ? '0px' : '24px',
//             gap: '16px',
//             flexWrap: 'wrap',
//             boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//             fontFamily: 'Outfit',
//           }}
//         >
//           {/* City with Autocomplete */}
//           <Box sx={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
//             <TextField
//               variant="outlined"
//               placeholder="City"
//               value={city}
//               onChange={handleCityChange}
//               onBlur={() => {
//                 setTimeout(() => setShowCitySuggestions(false), 200);
//               }}
//               onFocus={() => {
//                 if (city.trim().length >= 1 && citySuggestions.length > 0) {
//                   setShowCitySuggestions(true);
//                 } else if (city.trim().length >= 1) {
//                   fetchCitySuggestions(city.trim());
//                 }
//               }}
//               fullWidth={isMobile}
//               error={!!cityError}
//               helperText={cityError}
//               sx={{
//                 width: '100%',
//                 '& .MuiInputBase-root': {
//                   height: '44px',
//                   fontFamily: 'Outfit',
//                   fontWeight: 500,
//                 },
//                 '& input': {
//                   padding: '10px 12px',
//                   fontWeight: 500,
//                   color: '#626262',
//                   fontFamily: 'Outfit',
//                 },
//                 '& .MuiFormHelperText-root': {
//                   color: 'red',
//                   marginTop: '2px',
//                   fontSize: '12px',
//                 },
//               }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <LocationOnIcon sx={{ color: '#aaa' }} />
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             {showCitySuggestions && citySuggestions.length > 0 && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '44px',
//                   left: 0,
//                   right: 0,
//                   zIndex: 10,
//                   maxHeight: '200px',
//                   overflowY: 'auto',
//                   backgroundColor: '#fff',
//                   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                   borderRadius: '4px',
//                   mt: '4px',
//                   border: '1px solid #e0e0e0',
//                 }}
//               >
//                 {citySuggestions.map((suggestion, index) => (
//                   <Box
//                     key={`city-${suggestion.id}-${index}`}
//                     sx={{
//                       padding: '10px 12px',
//                       cursor: 'pointer',
//                       borderBottom: index < citySuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       fontFamily: 'Outfit',
//                       fontWeight: 500,
//                       color: '#626262',
//                     }}
//                     onMouseDown={(e) => {
//                       e.preventDefault();
//                       e.stopPropagation();
//                       setCity(suggestion.name);
//                       setCityError('');
//                       setShowCitySuggestions(false);
//                       // Clear area when city changes
//                       setArea('');
//                       setAreaSuggestions([]);
//                       // UPDATED: Clear area cache when city changes
//                       setAreaCacheMap({});
//                     }}
//                   >
//                     <Box>
//                       <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
//                         {suggestion.name}
//                       </Typography>
//                       {suggestion.state_name && (
//                         <Typography sx={{ fontSize: '12px', color: '#999' }}>
//                           {suggestion.state_name}
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             )}
//           </Box>

//           {/* Area with Autocomplete */}
//           <Box sx={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
//             <TextField
//               variant="outlined"
//               placeholder="Area"
//               value={area}
//               onChange={handleAreaChange}
//               onBlur={() => {
//                 setTimeout(() => setShowAreaSuggestions(false), 200);
//               }}
//               onFocus={() => {
//                 // UPDATED: Show existing suggestions or fetch if empty
//                 if (city && city.trim() !== '' && areaSuggestions.length > 0) {
//                   setShowAreaSuggestions(true);
//                 } else if (city && city.trim() !== '' && area.trim().length === 0) {
//                   fetchAreaSuggestions('');
//                 }
//               }}
//               fullWidth={isMobile}
//               error={!!areaError}
//               helperText={areaError}
//               disabled={!city || city.trim() === ''}
//               sx={{
//                 width: '100%',
//                 '& .MuiInputBase-root': {
//                   height: '44px',
//                   fontFamily: 'Outfit',
//                   fontWeight: 500,
//                 },
//                 '& input': {
//                   padding: '10px 12px',
//                   fontWeight: 500,
//                   color: '#626262',
//                   fontFamily: 'Outfit',
//                 },
//                 '& .MuiFormHelperText-root': {
//                   color: 'red',
//                   marginTop: '2px',
//                   fontSize: '12px',
//                 },
//               }}
//             />

//             {/* Area Suggestions Dropdown */}
//             {showAreaSuggestions && !isLoadingAreas && areaSuggestions.length > 0 && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '44px',
//                   left: 0,
//                   right: 0,
//                   zIndex: 10,
//                   maxHeight: '200px',
//                   overflowY: 'auto',
//                   backgroundColor: '#fff',
//                   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                   borderRadius: '4px',
//                   mt: '4px',
//                   border: '1px solid #e0e0e0',
//                 }}
//               >
//                 {areaSuggestions.map((suggestion, index) => (
//                   <Box
//                     key={`area-${index}-${suggestion.name}`}
//                     sx={{
//                       padding: '10px 12px',
//                       cursor: 'pointer',
//                       borderBottom: index < areaSuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       fontFamily: 'Outfit',
//                       fontWeight: 500,
//                       color: '#626262',
//                     }}
//                     onMouseDown={(e) => {
//                       e.preventDefault();
//                       e.stopPropagation();
//                       setArea(suggestion.name);
//                       setAreaError('');
//                       setShowAreaSuggestions(false);
//                     }}
//                   >
//                     <Box>
//                       <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
//                         {suggestion.name}
//                       </Typography>
//                       {suggestion.address && (
//                         <Typography sx={{ fontSize: '12px', color: '#999' }}>
//                           {suggestion.address}
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             )}

//             {/* NEW: Loading indicator */}
//             {/* {isLoadingAreas && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '44px',
//                   left: 0,
//                   right: 0,
//                   zIndex: 10,
//                   backgroundColor: '#fff',
//                   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                   borderRadius: '4px',
//                   mt: '4px',
//                   border: '1px solid #e0e0e0',
//                   padding: '10px',
//                   textAlign: 'center',
//                 }}
//               >
//                 <Typography sx={{ fontSize: '14px', color: '#999', fontFamily: 'Outfit' }}>
//                   Loading areas...
//                 </Typography>
//               </Box>
//             )} */}
//           </Box>

//           {/* Search Button */}
//           <Button
//             onClick={handleSearch}
//             variant="contained"
//             sx={{
//               bgcolor: '#0052ff',
//               color: '#fff',
//               width: isMobile ? '100%' : '120px',
//               height: '44px',
//               textTransform: 'none',
//               fontWeight: 500,
//               fontFamily: 'Outfit',
//               borderRadius: '6px',
//               '&:hover': {
//                 backgroundColor: '#003dcc',
//               },
//             }}
//           >
//             Search
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default HeroSection;


import React, { useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Typography,
  TextField,
  useMediaQuery,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../../assets/hij.png';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../Commonlibs/userSlice';

const HeroSection = () => {
  const [activeTab, setActiveTab] = useState('Buy');
  const [city, setCity] = useState('');
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [showCitySuggestions, setShowCitySuggestions] = useState(false);
  const [area, setArea] = useState('');
  const [areaSuggestions, setAreaSuggestions] = useState([]);
  const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);

  // Debounce timers
  const [cityDebounceTimer, setCityDebounceTimer] = useState(null);
  const [areaDebounceTimer, setAreaDebounceTimer] = useState(null);

  // Field validation states
  const [cityError, setCityError] = useState('');
  const [areaError, setAreaError] = useState('');

  // Dialog state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogSeverity, setDialogSeverity] = useState('info');

  // NEW: Cache for area suggestions
  const [areaCacheMap, setAreaCacheMap] = useState({});

  // NEW: Loading state for areas
  const [isLoadingAreas, setIsLoadingAreas] = useState(false);

  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const user = useSelector(selectUser);

  const tabs = ['Buy', 'Rent']; //'Plots'

  const categoryMap = {
    'Buy': 'sale',
    'Rent': 'rent',
    // 'Plots': 'plot'
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const showDialog = (message, severity = 'info') => {
    setDialogMessage(message);
    setDialogSeverity(severity);
    setDialogOpen(true);
  };

  const validateCity = (value) => {
    if (value) {
      if (!/^[a-zA-Z\s]+$/.test(value)) {
        setCityError('City should contain only letters and spaces');
        return false;
      }
    }
    setCityError('');
    return true;
  };

  const validateArea = (value) => {
    if (value) {
      if (!/^[a-zA-Z0-9\s,.-]+$/.test(value)) {
        setAreaError('Area should contain only alphanumeric characters, spaces and basic punctuation');
        return false;
      }
    }
    setAreaError('');
    return true;
  };

  const fetchCitySuggestions = async (query) => {
    if (!query || query.trim().length < 1) {
      setCitySuggestions([]);
      setShowCitySuggestions(false);
      return;
    }

    try {
      const response = await axios.get(
        `https://propertydealstalk.com/api/property/cities?q=${encodeURIComponent(query)}`
      );
      console.log('City API Response:', response.data);

      if (response.data.success && response.data.data && response.data.data.length > 0) {
        setCitySuggestions(response.data.data);
        setShowCitySuggestions(true);
      } else {
        setCitySuggestions([]);
        setShowCitySuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching city suggestions:', error);
      console.error('Error details:', error.response?.data);
      setCitySuggestions([]);
      setShowCitySuggestions(false);
    }
  };

  // UPDATED: Area suggestions with caching and loading state
  const fetchAreaSuggestions = async (query) => {
    if (!city || city.trim() === '') {
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
      return;
    }

    // Create cache key
    const cacheKey = `${city.trim()}_${query.trim()}`;

    // Check if we have cached results
    if (areaCacheMap[cacheKey]) {
      console.log('Using cached area suggestions');
      setAreaSuggestions(areaCacheMap[cacheKey]);
      setShowAreaSuggestions(true);
      return;
    }

    setIsLoadingAreas(true);

    try {
      const response = await axios.get(
        `https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`
      );
      console.log('Area API Response:', response.data);

      if (response.data.success && response.data.areas && response.data.areas.length > 0) {
        // Cache the results
        setAreaCacheMap(prev => ({
          ...prev,
          [cacheKey]: response.data.areas
        }));

        setAreaSuggestions(response.data.areas);
        setShowAreaSuggestions(true);
      } else {
        setAreaSuggestions([]);
        setShowAreaSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching area suggestions:', error);
      console.error('Error details:', error.response?.data);
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    } finally {
      setIsLoadingAreas(false);
    }
  };

  const saveBuyerSearch = async (searchData) => {
    try {
      const response = await axios.post(
        'https://propertydealstalk.com/api/buyerAnalytics/saveBuyerSearch',
        searchData
      );

      if (response.data.statusCode === 200) {
        console.log('Search saved successfully:', response.data);
      } else {
        console.error('Failed to save search:', response.data);
      }
    } catch (error) {
      console.error('Error saving search:', error);
    }
  };

  const handleSearch = async () => {
    // Validate both fields
    const isCityValid = validateCity(city);
    const isAreaValid = validateArea(area);

    if (!isCityValid || !isAreaValid) {
      return;
    }

    const hasCity = city && city.trim() !== '';
    const hasArea = area && area.trim() !== '';

    // UPDATED: Both city and area are required
    if (!hasCity || !hasArea) {
      showDialog("Please provide both City and Area to search", "warning");
      return;
    }

    const params = new URLSearchParams();
    const categoryType = categoryMap[activeTab];

    if (categoryType) {
      params.append('type_of_category', categoryType);
    }

    params.append('city', city.trim());
    params.append('area_name', area.trim());

    if (user && user.id) {
      const searchData = {
        buyer_id: user.id,
        location: city.trim(),
        area: area.trim(),
        property_type: null,
        min_price: null,
        max_price: null
      };
      await saveBuyerSearch(searchData);
    }

    navigate({
      pathname: '/property',
      search: params.toString()
    });

    showDialog('Searching for properties...', 'success');
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setCity(value);
    validateCity(value);

    // Clear existing timer
    if (cityDebounceTimer) {
      clearTimeout(cityDebounceTimer);
    }

    // Set new timer for debouncing
    const newTimer = setTimeout(() => {
      if (value.trim().length >= 1) {
        fetchCitySuggestions(value.trim());
      } else {
        setCitySuggestions([]);
        setShowCitySuggestions(false);
      }
    }, 300);

    setCityDebounceTimer(newTimer);
  };

  // UPDATED: Reduced debounce time to 100ms
  const handleAreaChange = (e) => {
    const value = e.target.value;
    setArea(value);
    validateArea(value);

    // Clear existing timer
    if (areaDebounceTimer) {
      clearTimeout(areaDebounceTimer);
    }

    // Set new timer for debouncing - REDUCED to 100ms
    const newTimer = setTimeout(() => {
      if (city && city.trim() !== '') {
        fetchAreaSuggestions(value);
      }
    }, 100); // Reduced from 300ms to 100ms

    setAreaDebounceTimer(newTimer);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: '600px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        fontFamily: 'Outfit',
        px: '16px',
      }}
    >
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {dialogSeverity === 'success' ? 'Success' :
            dialogSeverity === 'warning' ? 'Warning' :
              dialogSeverity === 'error' ? 'Error' : 'Information'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.6)',
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '880px',
          maxWidth: '100%',
          fontFamily: 'Outfit',
        }}
      >
        <Typography
          variant="h3"
          sx={{
            textAlign: 'center',
            fontWeight: 500,
            mb: '8px',
            fontSize: isMobile ? '28px' : '40px',
            fontFamily: 'Outfit',
          }}
        >
          Buy, Sell, Rent a Property made easy !
        </Typography>

        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            fontWeight: 500,
            mb: '32px',
            fontSize: isMobile ? '16px' : '20px',
            fontFamily: 'Outfit',
          }}
        >
          Browse through thousands of properties for sale and rent
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: isMobile ? 'center' : 'flex-start',
            flexWrap: 'wrap',
            gap: isMobile ? '5px' : '10px',
            px: isMobile ? '0px' : '30px',
            mb: '0px',
          }}
        >
          {tabs.map((label) => (
            <Box
              key={label}
              onClick={() => setActiveTab(label)}
              sx={{
                width: isMobile ? '100px' : '160px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                fontWeight: 500,
                fontFamily: 'Outfit',
                fontSize: '14px',
                textTransform: 'uppercase',
                cursor: 'pointer',
                backgroundColor: activeTab === label ? '#0052ff' : '#ffffff',
                color: activeTab === label ? '#ffffff' : '#000000',
                boxShadow: activeTab === label ? '0px 2px 8px rgba(0, 0, 0, 0.2)' : 'none',
                border: '1px solid grey',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: activeTab === label ? '#0041cc' : '#f5f5f5',
                },
              }}
            >
              {label}
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundColor: '#fff',
            borderRadius: '12px',
            padding: '20px',
            mt: '0px',
            ml: isMobile ? '0px' : '24px',
            mr: isMobile ? '0px' : '24px',
            gap: '16px',
            flexWrap: 'wrap',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            fontFamily: 'Outfit',
          }}
        >
          {/* City with Autocomplete */}
          <Box sx={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
            <TextField
              variant="outlined"
              placeholder="City"
              value={city}
              onChange={handleCityChange}
              onBlur={() => {
                setTimeout(() => setShowCitySuggestions(false), 200);
              }}
              onFocus={() => {
                if (city.trim().length >= 1 && citySuggestions.length > 0) {
                  setShowCitySuggestions(true);
                } else if (city.trim().length >= 1) {
                  fetchCitySuggestions(city.trim());
                }
              }}
              fullWidth={isMobile}
              error={!!cityError}
              helperText={cityError}
              sx={{
                width: '100%',
                '& .MuiInputBase-root': {
                  height: '44px',
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                },
                '& input': {
                  padding: '10px 12px',
                  fontWeight: 500,
                  color: '#626262',
                  fontFamily: 'Outfit',
                },
                '& .MuiFormHelperText-root': {
                  color: 'red',
                  marginTop: '2px',
                  fontSize: '12px',
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocationOnIcon sx={{ color: '#aaa' }} />
                  </InputAdornment>
                ),
              }}
            />

            {showCitySuggestions && citySuggestions.length > 0 && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '44px',
                  left: 0,
                  right: 0,
                  zIndex: 10,
                  maxHeight: '200px',
                  overflowY: 'auto',
                  backgroundColor: '#fff',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  borderRadius: '4px',
                  mt: '4px',
                  border: '1px solid #e0e0e0',
                }}
              >
                {citySuggestions.map((suggestion, index) => (
                  <Box
                    key={`city-${suggestion.id}-${index}`}
                    sx={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: index < citySuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      fontFamily: 'Outfit',
                      fontWeight: 500,
                      color: '#626262',
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setCity(suggestion.name);
                      setCityError('');
                      setShowCitySuggestions(false);

                      // Clear area when city changes
                      setArea('');
                      setAreaSuggestions([]);
                      // UPDATED: Clear area cache when city changes
                      setAreaCacheMap({});
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
                        {suggestion.name}
                      </Typography>
                      {suggestion.state_name && (
                        <Typography sx={{ fontSize: '12px', color: '#999' }}>
                          {suggestion.state_name}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          {/* Area with Autocomplete */}
          <Box sx={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
            <TextField
              variant="outlined"
              placeholder="Area"
              value={area}
              onChange={handleAreaChange}
              onBlur={() => {
                setTimeout(() => setShowAreaSuggestions(false), 200);
              }}
              onFocus={() => {
                // UPDATED: Show existing suggestions or fetch if empty
                if (city && city.trim() !== '' && areaSuggestions.length > 0) {
                  setShowAreaSuggestions(true);
                } else if (city && city.trim() !== '' && area.trim().length === 0) {
                  fetchAreaSuggestions('');
                }
              }}
              fullWidth={isMobile}
              error={!!areaError}
              helperText={areaError}
              disabled={!city || city.trim() === ''}
              sx={{
                width: '100%',
                '& .MuiInputBase-root': {
                  height: '44px',
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                },
                '& input': {
                  padding: '10px 12px',
                  fontWeight: 500,
                  color: '#626262',
                  fontFamily: 'Outfit',
                },
                '& .MuiFormHelperText-root': {
                  color: 'red',
                  marginTop: '2px',
                  fontSize: '12px',
                },
              }}
            />

            {/* Area Suggestions Dropdown */}
            {showAreaSuggestions && !isLoadingAreas && areaSuggestions.length > 0 && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '44px',
                  left: 0,
                  right: 0,
                  zIndex: 10,
                  maxHeight: '200px',
                  overflowY: 'auto',
                  backgroundColor: '#fff',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  borderRadius: '4px',
                  mt: '4px',
                  border: '1px solid #e0e0e0',
                }}
              >
                {areaSuggestions.map((suggestion, index) => (
                  <Box
                    key={`area-${index}-${suggestion.name}`}
                    sx={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: index < areaSuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      fontFamily: 'Outfit',
                      fontWeight: 500,
                      color: '#626262',
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setArea(suggestion.name);
                      setAreaError('');
                      setShowAreaSuggestions(false);
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
                        {suggestion.name}
                      </Typography>
                      {suggestion.address && (
                        <Typography sx={{ fontSize: '12px', color: '#999' }}>
                          {suggestion.address}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}

            {/* NEW: Loading indicator */}
            {/* {isLoadingAreas && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '44px',
                  left: 0,
                  right: 0,
                  zIndex: 10,
                  backgroundColor: '#fff',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  borderRadius: '4px',
                  mt: '4px',
                  border: '1px solid #e0e0e0',
                  padding: '10px',
                  textAlign: 'center',
                }}
              >
                <Typography sx={{ fontSize: '14px', color: '#999', fontFamily: 'Outfit' }}>
                  Loading areas...
                </Typography>
              </Box>
            )} */}
          </Box>

          {/* Search Button */}
          <Button
            onClick={handleSearch}
            variant="contained"
            sx={{
              bgcolor: '#0052ff',
              color: '#fff',
              width: isMobile ? '100%' : '120px',
              height: '44px',
              textTransform: 'none',
              fontWeight: 500,
              fontFamily: 'Outfit',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#003dcc',
              },
            }}
          >
            Search
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;